import { Message } from "semantic-ui-react";
import { useEffect, useState } from "react";
import { useFetchUtilityStrike, useUtilityStrikeTeams, useUtilityStrikeForms } from "./UtilityStrikeFetchData";
import UtilityStrikeFormsContent from "./UtilityStrikeFormsContent";

export const UtilityStrike = () => {
    const {
        fetchData,
        error,
        success,
    } = useFetchUtilityStrike();

    const {
        team,
        teams,
        getTeams,
    } = useUtilityStrikeTeams(fetchData);

    const {
        utilityStrikeForms,
        setUtilityStrikeForms,
        getUtilityStrikeForms,
    } = useUtilityStrikeForms(fetchData);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getTeams();
    }, [getTeams]);

    useEffect(() => {
        setLoading(true);
        if (team && team.id) {
            getUtilityStrikeForms().then(() => setLoading(false));
        } else {
            setUtilityStrikeForms({});
            setLoading(false);
        }
    }, [team, getUtilityStrikeForms, setUtilityStrikeForms]);

    return (
        <div>
            {error !== '' &&
                <Message style={{ width: "fit-content" }} compact negative>{error}</Message>
            }
            <UtilityStrikeFormsContent utilityStrikeForms={utilityStrikeForms} userTeams={teams} />
        </div>
    );
};